const englishLocaleRegex = /^en-US/;
const removeSlashesRegex = /\//g;
const removeUnderscoreRegex = /_/g;
const trailingSlashRegex = /\/+$/;

//returns true if the obj is falsy, missing, or an empty object
//returns false if the object is valid and has a key
export function isEmptyObject(obj) {
    if (!obj) return true;
    if (typeof obj === 'string') return true;
    return !Object.keys(obj).length;
}

//sanitize the page string to drop the leading slash to ensure its only one is there in the request
export function getPageNoLeadingSlash(pageSlug) {
    if (!pageSlug) return '';
    let pageNoLeadingSlash = pageSlug;
    if (pageNoLeadingSlash && pageNoLeadingSlash[0] === '/') {
        pageNoLeadingSlash = pageSlug.slice(1, pageSlug.length);
    }
    return pageNoLeadingSlash;
}

//sanitize the locale to remove any slashes and underscores
export function getNoSlashLocale(locale) {
    if (!locale) return '';
    return locale.replace(removeSlashesRegex, '').replace(removeUnderscoreRegex, '-');
}

export function getLocalePageSlug(locale, pageSlug) {
    const noSlashLocale = getNoSlashLocale(locale);
    const isEnglishLocale = englishLocaleRegex.test(noSlashLocale);
    const pageNoLeadingSlash = getPageNoLeadingSlash(pageSlug);
    let localePageSlug;

    //we dont want a trailing slash for non english locales. we need to add the locale for non english as well
    if (isEnglishLocale) {
        localePageSlug = `/${pageNoLeadingSlash}`;
    } else if (pageNoLeadingSlash) {
        localePageSlug = `/${noSlashLocale}/${pageNoLeadingSlash}`;
    } else {
        localePageSlug = `/${noSlashLocale}`;
    }

    return {
        localePageSlug,
        isEnglishLocale,
        pageNoLeadingSlash,
        noSlashLocale
    };
}

export function getNoTrailingSlash(url) {
    if (!url) {
        return '';
    }
    return url.replace(trailingSlashRegex, '');
}

/**
 * A safe to use locale pattern regex.
 *
 * @param  {Array} Use the negativeLookupArray param ['vr', 'ar'] to include 2 letter pages on your app that shouldnt be locales
 * @return {RegExp}
 */
export function getLocalePattern(negativeLookupArray) {
    throw new Error(
        'getLocalePattern() was moved to @epic-core/localization/src/locale/utils. Please update your import'
    );
}

export function extractSlugLocale(pathname, locale) {
    throw new Error(
        'extractSlugLocale() was moved to @epic-core/localization/src/locale/utils. Please update your import'
    );
}
